__turbopack_context__.v({
  "closeButton": "Modal-module-scss-module__lkFYUa__closeButton",
  "dialog": "Modal-module-scss-module__lkFYUa__dialog",
  "overlay": "Modal-module-scss-module__lkFYUa__overlay",
});
